module.exports = __webpack_public_path__ + "static/media/banner1.cf073e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/davi/images/banner1.jpg
// module id = 513
// module chunks = 0